import React from 'react';
import { getEducationLevelOptions } from '../../utils/enrollmentUtils';

// `disabledLevels` maps a level to the name of the fund already holding it.
// A level can belong to only one fund, so those options are locked and say
// which fund has them rather than just appearing greyed out for no reason.
const EducationLevelMultiSelect = ({ value = [], onChange, disabledLevels = {} }) => {
  const toggleLevel = (level) => {
    if (disabledLevels[level]) return;
    onChange(value.includes(level) ? value.filter(item => item !== level) : [...value, level]);
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
      {getEducationLevelOptions().map(option => {
        const checked = value.includes(option.value);
        const takenBy = disabledLevels[option.value];
        const disabled = Boolean(takenBy);

        return (
          <label
            key={option.value}
            title={disabled ? `Already assigned to ${takenBy}` : undefined}
            className={`flex items-center gap-2 rounded-xl border px-3 py-2.5 text-sm transition-colors ${
              disabled
                ? 'cursor-not-allowed border-gray-200 bg-gray-100 text-gray-400'
                : checked
                  ? 'cursor-pointer border-indigo-300 bg-indigo-50 text-indigo-800'
                  : 'cursor-pointer border-gray-200 bg-gray-50 text-gray-600 hover:bg-gray-100'
            }`}
          >
            <input
              type="checkbox"
              checked={checked}
              disabled={disabled}
              onChange={() => toggleLevel(option.value)}
              className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 disabled:cursor-not-allowed"
            />
            <span className="min-w-0">
              {option.label}
              {disabled && (
                <span className="block text-[11px] leading-tight text-gray-400 truncate">
                  In {takenBy}
                </span>
              )}
            </span>
          </label>
        );
      })}
    </div>
  );
};

export default EducationLevelMultiSelect;
